import { Label as ShadcnLabel } from "@/components/ui/label";
import * as React from "react";

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(({ className, ...props }, ref) => (
    <ShadcnLabel ref={ref} className={className} {...props} />
));
Label.displayName = "Label";
